module.exports = __webpack_public_path__ + "static/media/ice36.a167e727.webp";